<template>
    <div class="Product">
      <div class="productbox hidden-sm-and-down main-container">
         <div class="procontainer">
            <div class="Productleft" :style="{ height : detailheight + 'px' }">
            <div style="background:#fff;margin-bottom:4px;">
               <img class="productimg" :src="imgsrc + thumbnailimg" alt="" />
            </div>
            <img :src="imgsrc + detailsimg" alt="">
          </div>
          <div class="Productrig"  ref="rightbox">
            <el-row style="padding-left: 6%">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                  <el-breadcrumb-item>{{ goodsInfo.product_classify }}</el-breadcrumb-item>
                  <el-breadcrumb-item>{{ goodsInfo.name }}</el-breadcrumb-item>
                </el-breadcrumb>
              <el-col>
                <div class="goods_title">
                  <h1>
                    {{ goodsInfo.name }}
                  </h1>
                </div>
                <div class="goods_describe" style="padding-right:5%;">
                  <span style="line-height: 2em">{{ goodsInfo.description }}</span>
                </div>
                <div class="goods_price">
                  <h1>{{ GoodsTotalPrice }}</h1>
                </div>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
              <el-col>
                <div class="rightbox">
                  <div class="goods_package" style="padding-left: 6%">
                    <h1 class="goods_package_lab">套餐</h1>
                    <div style="display: inline-block; margin: 2.5% 0">
                      <el-radio-group
                        v-model="radioButton"
                        size="medium"
                        @change="handleRadioButtonChange"
                      >
                        <el-radio-button
                          v-for="(specs_item, index) in goodsInfo.specs"
                          :key="index"
                          :label="index"
                        >
                          {{ specs_item.group }}
                        </el-radio-button>
                      </el-radio-group>
                    </div>
                  </div>
                  <!-- <div class="goods_number" style="padding-left: 6%">
                    <span class="goods_number_lab">购买数量</span>
                    <el-input-number v-model="goodsNumber" @change="handleChange" :min="1" :max="99" type=Number></el-input-number>
                  </div>
                  <div style="margin:0 0 6% 0; padding-left: 6%; display: inline-flex;">
                    <el-button type="danger" @click="incar" ref="btn"
                      >加入购物车</el-button
                    >
                    <el-button type="danger"  @click="incar('now')"
                      >立即购买</el-button
                    >
                  </div> -->
                  <el-divider></el-divider>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <div style="padding-left: 6%;padding-right:3%;">
                  <el-collapse accordion>
                  <el-collapse-item>
                    <template slot="title">
                    成分及功效
                    </template>
                    <div style="color:#00383F;font-size:14px">{{ goodsInfo.element_effect }}</div>
                  </el-collapse-item>
                </el-collapse>
                </div>
                <el-divider></el-divider>
              </el-col>
            </el-row>

            <div style="margin: 2% 0; padding-left: 6%" v-if="listdata.length>0">
              <h1 class="goods_package_lab">推荐搭配</h1>
                <div class="probox">
                  <el-row :gutter="20">
                    <el-col :xl="8" :lg="8" :md="12" :sm="12" :xs="12"  v-for="(item, index) in listdata" :key="index">
                      <div class="grid-content bg-purple">
                        <router-link :to="{ name:'Product', query: {id: item.id} }" style="display: inline-block;">
                        <img class="qwimg" v-if="item.is_authority == 1" src="../../static/qw.png" alt="">
                        <img class="procover" :src="imgsrc + item.cover" alt="" />
                        <span>{{ item.product_classify }}</span>
                        <p>{{ item.name }}</p>
                        <h5 v-if="isPriceOnRequest(item.unit_price)">价格详询在售渠道</h5>
                        <h5 v-else>￥{{ item.unit_price }}</h5>
                        </router-link>
                      </div>
                    </el-col>
                  </el-row>
                </div>
            </div>
          </div>
         </div>
        <div style="clear:both;"></div>
      </div>
      <!-- 手机端显示 -->
      <div class="hidden-md-and-up mbproduct">
          <div  class="productimg" >
            <img :src="imgsrc + thumbnailimg" alt="" />
          </div>
          <div class="prodictdetail">
            <p> {{ goodsInfo.name }}</p>
            <span>成分及功效</span>
            <div>{{ goodsInfo.element_effect }}</div>

            <div class="collect">
              <img v-if="goodsInfo.is_collaction == 0" @click="collClick" src=" ../../static/mobile/sc3.png" alt="">
              <img v-if="goodsInfo.is_collaction == 1" @click='delClick' src="../../static/mobile/scred.png" alt="">
              <span>收藏</span>
            </div>
          </div>
      </div>
      <!-- 详情推荐搭配 -->
      <div class="hidden-md-and-up">
        <tab-slide :notice="{detailsimg:detailsimg,listdata:listdata}"></tab-slide>
      </div>
      <!-- 产品tabbar -->
      <!-- <div class="producttabBar hidden-md-and-up">
        <ul>
          <li>
            <router-link to="/">
                <img style="width:80%;max-width:0.52rem;" src="../../static/mobile/shouye.png" alt="">
                <span>首页</span>
               </router-link>
          </li>
          <li>
          <router-link to="/collection">
              <img  style="width:80%;max-width:0.53rem;" src=" ../../static/mobile/sc2.png" alt="">
                <span>收藏</span>
          </router-link>
          </li>
          <li @click="drawerClick()">
              加入购物车
          </li>
          <li @click="drawerClick('no')">
            立即购买
          </li>
        </ul>

        <el-drawer
          title="我是标题"
          :visible.sync="drawer"
          :direction="direction"
          :append-to-body = "true"
          size ='6.3rem'
          :with-header="false">
          <div class="prodetail">
            <div class="prodetailtop"> 
              <div>
                <img :src="imgsrc + thumbnailimg" alt="" />
              </div>
               <p> {{ goodsInfo.name }}</p>
            </div>
                <div class="prodetailsub">
                   <h1>选择套餐</h1>
                <div style="margin-bottom:0.3rem">
                      <el-radio-group
                        v-model="radioButton"
                        size="medium"
                        @change="handleRadioButtonChange"
                      >
                        <el-radio-button
                          v-for="(specs_item, index) in goodsInfo.specs"
                          :key="index"
                          :label="index"
                        >
                          {{ specs_item.group }}
                        </el-radio-button>
                      </el-radio-group>
                    </div>
            </div>
            <div class="number">
                <div class="goods_number_lab">购买数量</div>
                <el-input-number v-model="goodsNumber" @change="handleChange" :min="1" :max="99" type=Number></el-input-number>
            </div>
            <div class="number_price">
              <span>合计</span>
              <h1>￥{{ GoodsTotalPrice }}</h1>
            </div>
            <div v-if="btn1" class="btncon"  @click="incar">
              确定
            </div>
              <div v-if="btn2" class="btncon"  @click="incar('now')">
              确定
            </div>
          </div>
        </el-drawer>
      </div> -->
    </div>
</template>

<script>
import elementResizeDetectorMaker from 'element-resize-detector'
import {product_detail_urlAPI,create_shopping_car_url,product_recommend_url,collect_url,collection_del_url} from "../request/api.js";
import tabSlide from "../components/tabSlide.vue";

export default {
  name: "ProductCopy",
  components: {tabSlide},
  directives: {},

  data() {
    return {
      html:'',
      goodId: 2, //产品编号
      goodsInfo: [],
      goodsPrice: 0,
      goodsNumber: 1,
      radioButton: 0,
      checkedGoodsPackagePrice: "",
      listdata: "",
      checkedGoodsPackageIndex: 0,
      thumbnailimg:this.imgLoading,
      detailsimg:this.imgLoading,
      detailheight:'',
      drawer: false,
       direction: 'btt',
       btn1:true,
       btn2:false,
       cur:0,
       flag:'',
       docH:0
    };
  },
  computed: {
    GoodsTotalPrice() {
      const unit = Number(this.checkedGoodsPackagePrice);
      if (!Number.isFinite(unit) || unit <= 0) {
        return '价格详询在售渠道';
      }
      this.goodsPrice = this.goodsNumber * unit;
      return '￥' + this.goodsPrice.toFixed(2);
    },
  },
  methods: {
    isPriceOnRequest(p) {
      const n = Number(p);
      return !Number.isFinite(n) || n <= 0;
    },
    drawerClick(id){
      if(id == 'no'){
        this.drawer = true
        this.btn2 = true
        this.btn1 = false
      }else{
        this.drawer = true
        this.btn2 = false
        this.btn1 = true
      }
    },
 
    watchSize() {
      const _this = this;

      var erd = elementResizeDetectorMaker();
      
      erd.listenTo(this.$refs.rightbox, (element) => {
          _this.$nextTick(() => { 
            if( window.innerWidth>=992){
              let mianHeight=window.innerHeight-154-this.$parent.$refs.footer.$el.offsetHeight
              this.detailheight= mianHeight>element.offsetHeight?mianHeight:element.offsetHeight
            }
          });
        });
      },

    // 收藏
    collClick(){
      if(!this.$store.state.isLogin){
        this.$message.success('请先登录');
        // this.$router.push({ path: "/Login" });
        setTimeout(() => {
          this.$router.push({ path: "/Login" });
        }, 2000);
      }else{
         collect_url({product_id:this.$route.query.id}).then((res)=>{
            if(res.data.code == 200){
            this.ProductDetail()
            }
     })
      }
    
    },
    //取消收藏
    delClick(){
      collection_del_url({product_id:this.$route.query.id}).then((res)=>{
         if(res.data.code == 200){
         this.ProductDetail()
        }
      })
    },
    //
    bag(){
      console.log('123')
    },
    // 商品信息
    ProductDetail() {
      this.goodId = this.$route.query.id;
      if (this.$route.query.id == undefined) {
        this.$router.push({ path: "/" });
      } else {
        product_detail_urlAPI({ id: this.goodId }).then((res) => {
          console.log(res)
          this.goodsInfo = res.data.data;
          console.log(this.goodsInfo)
          this.thumbnailimg = this.goodsInfo.thumbnail?this.goodsInfo.thumbnail[0]:''
          this.detailsimg = this.goodsInfo.details?this.goodsInfo.details[0]:''
          this.html = this.goodsInfo.video
          console.log(this.goodsInfo == null)
          if (this.goodsInfo == null) {
            this.$router.push({ path: "/" });
          } else {
            this.checkedGoodsPackagePrice = this.goodsInfo.specs?this.goodsInfo.specs[0].price:99999999;
          }
        });
      }
    },
    //推荐搭配
    getProductRecommend(){
      product_recommend_url({id:this.$route.query.id}).then((res)=>{
        this.listdata = res.data.data
          let mianHeight=window.innerHeight-154-this.$parent.$refs.footer.$el.offsetHeight
          this.detailheight = mianHeight>this.$refs.rightbox.offsetHeight?mianHeight:this.$refs.rightbox.offsetHeight
      })
    },
    handleChange(value) {
      console.log(value);
    },
    handleRadioButtonChange(value) {
      this.checkedGoodsPackageIndex = value;
      this.checkedGoodsPackagePrice = this.goodsInfo.specs?this.goodsInfo.specs[value].price:9999999;
      this.goodsNumber = 1;
    },
    //加入购物车和购买
    incar(buy) {
      this.$refs.btn.$el.style.background = '#bb2041'
      this.$refs.btn.$el.style.borderColor = '#bb2041'
      let _self = this;
      if (this.$store.state.token) {
        if (this.checkedGoodsPackageIndex === "") {
          prompt_error("请选择一个套餐");
        } else {
          let postParams = {
            p_id: this.goodId,
            num: this.goodsNumber,
            arr_id: this.checkedGoodsPackageIndex,
            freight: this.goodsInfo.freight,
            freight_status: this.goodsInfo.freight_status,
          };
          if (buy == "now") {
            this.$cookies.set("nowbuy", postParams);
            this.$router.push({path: '/ordersIn'});
            this.$router.push({ path: "/ordersIn", query: { page: "p" } });
          } else {
            create_shopping_car_url(postParams).then((res) => {
              if (res.data.code === 200) {
                //  获取并更新购物车数量
                this.$store.dispatch("getCarCount");
                this.$message.success("添加完成");
                this.drawer=false;
              }
            });
          }
        }
      } else {
        this.$message.error("请先登录，即将跳转登录页面");
        setTimeout(function () {
          _self.$router.push({ path: "/Login" });
        }, 1000);
      }
    },
  },
  mounted() {
    this.ProductDetail();
    this.getProductRecommend()
    this.watchSize();
  },
};
</script>

<style lang="less" scoped>
/deep/.el-breadcrumb__inner.is-link:hover{
  color: #00383F!important;
}
/deep/.el-breadcrumb__inner{
  color: #00383F!important;
}
/deep/.el-breadcrumb{
  margin-top: 4.8%!important;
}
/deep/.el-breadcrumb__separator{
   color: #00383F;
}
/deep/.el-breadcrumb__inner{
  color: #00383F;
}
// .el-col-md-8{
//   width: 24%;
// }
/deep/.el-divider--horizontal{
  margin:10px 0!important;
}
.Product {
      width: 100%;
      display: block;
      max-width: 1920px;
    margin: 0 auto;
  .Productleft::-webkit-scrollbar {
  display: none;
  
}
@media (min-width:1920px) {
  .productbox{
    background-size:1920px auto,1920px auto,1920px 720px!important;
    background-position: center top, center bottom, center 434px!important;
  }
}

.productbox{
  width: 100%;
  background-image: url(../../static/productbg_01.jpg),url(../../static/productbg_03.jpg),url(../../static/productbg_02.jpg);
  background-size:100% auto,100% auto,100% calc(100% - 45vw);
  background-repeat: no-repeat;
  background-position: center top, center bottom, center 22.3vw;
  min-height: calc(100vh - 300px);

  .procontainer{
    width: 80%;
    margin: 0 auto;
        .Productleft {
            width: 55%;
            float: left;
            overflow: auto;
            .productimg{
              width: 40%;
              margin: 10% 0;
            }
            img {
              width: 100%;
            }
          }
      .Productrig {
        width: 45%;
        float: right;
        text-align: left;
        background-size:100% 100%;
        color: #00383F;
        .goods_package_lab{
          font-size: 20px;
          color: #00383F;
          margin-bottom: 2%;
          margin-top: 3%;
        }
        .goods_title{
          h1{
            font-size: 38px;
            font-weight: 400;
            margin: 2.5% 0;
             font-family: "SimSun";
          }
        }
        .goods_price{
          h1{
            font-size: 24px;
            margin: 2.5% 0;
             font-family: "SimSun";
          }
        }
        .rightbox {
          width: 100%;
          .goods_number{
            color:#00383F ;
            font-size: 20px;
            padding-top: 6%;
            padding-bottom: 6%;
            .goods_number_lab{
              margin-right: 50px;
            }
          }
        }
      .probox {
          .bg-purple{
              background:url('../../static/detailbj.png')no-repeat;
              background-size:100% 100%;
              position: relative;
              max-width: 170px;
              margin-bottom: 52px;
              z-index: 1;
              text-align: center;
          }
          .qwimg{
            width:35%;
            max-width:124px;
            position: absolute;
            left: 15%;
            top: 10%;
            z-index: -1;
          }
          .procover {
            width: 80%;
            margin-top: 19%;
          }
          span {
            display: inline-block;
            width: 100%;
            margin: 20% 0 13% 0;
            font-size: 16px;
            color: #00383F;
            font-weight: bold;
          }
          p {
            margin-bottom: 10%;
            font-size: 18px;
            color: #00383f;
            font-weight: 200;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            font-size: 11px;
          }
          h5{
              font-size: 11px;
              padding-bottom: 5%;
              color: #00383f;
          }
        }
      }
  }

}

  /deep/.el-collapse-item__header{
    background: unset;
    border: unset;
    color: #00383F!important;
    font-size: 20px;
  }
  /deep/.el-collapse-item__arrow{
    color: #00383F;
  }
  /deep/.el-collapse-item__wrap{
    background: unset;
    border-bottom:unset;
  }
  /deep/.el-collapse{
    border: unset;
  }
  /deep/.el-divider{
    background-color:rgba(0, 56, 63, 0.5);
  }
  /deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: #00383F;
    border-color: #00383F;
    border: 1px solid #00383F !important;
    color: #fff;
  }
  /deep/.el-input-number__decrease, .el-input-number__increase{
    color:#00383F;
    font-size: 18px;
     background: unset!important;
  }
  /deep/.el-input-number__increase{
    color:#00383F;
    font-size: 18px;
     background: unset!important;
  }

  /deep/.el-radio-button__inner{
    background: unset;
    color:#00383F;
    border-radius:unset!important;
    border: 1px solid #00383F !important;
  }
  /deep/.el-input__inner{
     border: 1px solid #00383F !important;
     background: unset;
      border-radius:unset!important;
  }

  /deep/.el-input-number__decrease{
    border-right: unset;
   background: #fff;
  }
  /deep/.el-button--danger{
    background: #00383F;
    border-color: #00383F;
    border-radius: unset;
    min-width: 122px;
    font-size: 16px;
  }
/deep/ .el-input-number__increase{
 border-left: unset;
  background: #fff;
}
/deep/.el-input-number{
  width: 120px;
}
  .el-card__body{
    img{
      width: 100%;
    }
  }
}


@media (max-width: 991px) {
  .mbproduct{
  width: 100%;
  .productimg{
    width: 100%;
    background:#fff;
    height: 4.77rem;
    background-size: 100% 100%;
    border-bottom:1px solid  rgba(0, 56, 63, 0.1);
    img{
      width: 3rem;
      padding-top: 0.86rem;
      padding-bottom: 0.91rem;
    }
  }
  .prodictdetail{
    margin: 0 0.5rem 0 0.4rem;
      color: #00383F;
      text-align: left;
      position: relative;
    p{
      font-size: 0.38rem;
      font-weight: 900;
      padding-bottom: 0.33rem;
      padding-top: 0.35rem;
    }
    span{
      font-weight: bold;
      font-size: 0.25rem;
      padding-bottom: 0.19rem;
      display: inline-block;
    }
    div{
      font-size: 0.21rem;
      width: 6.5rem;
      padding-bottom: 0.41rem;
    }
    .collect{
      width: 0.7rem;
      text-align: center;
      color: #C0C0C0;
      position: absolute;
      top: 0.36rem;
      right: 0;
      span{
        font-size: 0.25rem;
        display: inline-block;
      }
      img{
        width: 0.41rem;
      }
    }
  }
}
.producttabBar{
  width: 100%;
  height: 1rem;
  position: fixed;
    bottom: 0;
    z-index: 222;
    background: #fff;
    ul{
       display: -webkit-flex;
        display: flex;
         height: 0.98rem;
        align-items: center;
        li{
          width: 20%;
          height: 0.98rem;
          border: 1px solid #00383F;
          color: #00383F;
         a{
            font-weight: bold;
            font-size: 0.21rem;
            display: inline-block;
          span{
            display: inline-block;
            width: 100%;
            font-size: 0.21rem;
         }
          img{
            padding-top: 0.12rem;
          }
         }
      
        }
           li:nth-child(2){
            border-left: unset;
        }
         li:nth-child(3){
           width: 30%;
            border-left: unset;
          font-size: 0.33rem;
          line-height: 0.98rem;
          font-weight: 900;
        }
           li:nth-child(4){
           width: 30%;
           border-left: unset;
          font-size: 0.33rem;
          line-height: 0.98rem;
          font-weight: 900;
          color: #F8FFFF;
          background: #00383F;
        }
    }
}
.prodetail{
  text-align: left;
  .prodetailtop{
  width: 100%;
  height: 1.34rem;
  border-bottom:1px solid rgba(0, 56, 63, 0.5);
  text-align: left;
    p{
      display: inline-block;
      font-size: 0.32rem;
      font-weight: bold;
      float: left;
      margin-left: 0.3rem;
      margin-top: 0.35rem;
    }
  div{
    width: 0.76rem;
    border: 1px solid rgba(0, 56, 63, 0.5);
    background: url(../../static/mobile/product.png) no-repeat;
    background-size: 100% 100%;
    display: inline-block;
    margin-top:0.13rem;
    margin-left: 0.51rem;
    float: left;
    img{
      width: 100%;
      padding: 0.15rem 0 0.15rem 0;
    }
  
  }
}
.prodetailsub{
   border-bottom:1px solid rgba(0, 56, 63, 0.5);
   padding-left: 0.4rem;
   height: 1.78rem;
  h1{
    font-size: 0.3rem;
    padding-top: 0.31rem;
    padding-bottom: 0.22rem;
  }
}
.number{
  padding: 0 0.4rem;
  height: 1.08rem;
  border-bottom:1px solid rgba(0, 56, 63, 0.5);
  overflow: hidden;
 .goods_number_lab{
   float: left;
   font-size: 0.26rem;
   margin:0.43rem 0;
 }
 .el-input-number{
   float: right;
   margin: 0.24rem 0;
  width: 2.2rem;
  line-height: 0.59rem;
 }
 /deep/.el-input__inner{
   height: 0.59rem;
   font-size: 0.29rem;
   color:#00383F ;
   line-height: 0.59rem;
    border:1px solid rgba(0, 56, 63, 0.5)!important;
 }
 /deep/.el-input-number__decrease{
   border-right: unset;
 }
 /deep/.el-input-number__increase{
   border-left: unset;
 }
}
.number_price{
  padding: 0 0.4rem;
  overflow: hidden;
  border-bottom:1px solid #00383F;
  span{
    display: inline-block;
    float: left;
    font-size: 0.3rem;
    margin: 0.3rem 0;
  }
  h1{
    display: inline-block;
    float: right;
    margin: 0.36rem 0;
    font-size: 0.25rem;
  }
}
.btncon{
  width: 100%;
  height: 1rem;
  background: #00383F;
  color: #fff;
  font-size: 0.33rem;
  text-align: center;
  line-height: 1rem;
}
}

/deep/.el-radio-button:last-child .el-radio-button__inner{
  border-radius:unset;
}
/deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner{
      background-color: #00383F!important;
}
}

</style>


// WEBPACK FOOTER //
// src/view/Product.vue